module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": 'Détails de la vérification'
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [(_vm.activateSpinner) ? _c('spinner') : _c('div', [_c('b-row', [_c('b-col', {
    staticStyle: {
      "border-right": "1px solid lightgrey"
    },
    attrs: {
      "sm": "6"
    }
  }, [_c('form-accordion', {
    attrs: {
      "title": 'Données de l\'entreprise'
    }
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('suppliers.supplier_id') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.siren))])]), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.social_reason') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.socialReason))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.dt_crtn') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.dateCreation))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('suppliers.legal_status') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.legalForm))])]), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('suppliers.core_business') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.coreBusiness))])])], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-accordion', {
    attrs: {
      "title": 'Données de l\'établissement'
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('suppliers.supplier_siret') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.siret))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "12"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.adrs') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.address))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.zp_code') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.postalCode))])]), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.cty') + ' : '))]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.town))])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.entity.getUBOs) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.entity.getUBOs) ? _c('form-accordion', {
    attrs: {
      "title": 'Bénéficiaires effectifs'
    }
  }, [(_vm.ubos.length) ? _c('b-row', {
    staticClass: "justify-content-start"
  }, _vm._l((_vm.ubos), function(ubo, index) {
    return _c('b-col', {
      key: index,
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [(ubo.Type === 'PP') ? _c('f7-icon', {
      attrs: {
        "fa": "user"
      }
    }) : _vm._e(), _vm._v(" "), (ubo.Type === 'PM') ? _c('f7-icon', {
      attrs: {
        "fa": "building"
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(ubo.LastName) + "\n            " + _vm._s(ubo.FirstName) + "\n            " + _vm._s(ubo.PercentageDetention + '%') + "\n          ")], 1)
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": 'Vérifications'
    }
  }, [_c('b-table', {
    staticClass: "resultsVerifications",
    attrs: {
      "hover": "",
      "bordered": "",
      "head-variant": "light",
      "items": _vm.verificationsItems,
      "fields": _vm.verificationsFields,
      "sort-by": 'id'
    },
    scopedSlots: _vm._u([{
      key: "cell(result)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center"
        }, [(data.value === 'KO') ? _c('i', {
          staticClass: "icon list-icon icon-error"
        }) : (data.value === 'WARN') ? _c('i', {
          staticClass: "icon list-icon icon-warning"
        }) : (data.value === 'INFO') ? _c('i', {
          staticClass: "icon list-icon icon-information"
        }) : _c('i', {
          staticClass: "icon list-icon icon-ok"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e67d864", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e67d864","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/VerificationsDetailPage.vue
// module id = 2374
// module chunks = 2